export default __webpack_public_path__ + "static/media/RTR 160 4V_2.3bfcf91b.webp";